// extracted by mini-css-extract-plugin
export default {"banner":"Topbanner_banner__jdOLx","banner__img":"Topbanner_banner__img__f8P-f","banner__overlay":"Topbanner_banner__overlay__o1B3k","banner__text":"Topbanner_banner__text__p5Pvm"};